import { createAsyncThunk } from '@reduxjs/toolkit';

const requestSubscriptionCancellation = createAsyncThunk(
  'billing/requestSubscriptionCancellation',
  async (
    payload,
    {
      rejectWithValue, extra: {
        sdk, Toast, localization, Logger,
      },
    },
  ) => {
    const {
      planName,
      reasons,
      additionalFeedback = null,
      retentionOfferShown = null,
      retentionCtaClicked = false,
    } = payload || {};

    try {
      Logger.log('User', 'CancellationFlowSubmitted', {
        reasons,
        retentionOfferShown,
        retentionCtaClicked,
        hasFeedback: Boolean(additionalFeedback),
      });

      await sdk.users.planCancellation({
        name: planName,
        reasons,
        additionalFeedback,
        retentionOfferShown,
        retentionCtaClicked,
      });

      const successCopy = localization.BILLING.CANCELLATION_FLOW.SUCCESS_TOAST;
      Toast(`${successCopy.title} ${successCopy.description}`, { type: 'success' });

      return { success: true };
    } catch (error) {
      Logger.log('UI', 'CancellationFlowSubmitFailed');
      Logger.error(
        new Error('Plan cancellation request failed'),
        { error },
        [
          'PlanCancellationFails',
          {
            showDialog: true,
            dialogTitle: localization.BILLING.CANCELLATION_FLOW.ERROR_TOAST.title,
            errorMessage: (error && error.message) || 'NoMessage',
            reasons: Array.isArray(reasons) ? reasons : [],
          },
        ],
      );
      return rejectWithValue(error);
    }
  },
);

export default requestSubscriptionCancellation;
